import { GameVer } from "./Lang";

export function stripSlashes(s: string) {
  let len = s.length;
  while (len > 1 && s[len - 1] === "/") {
    len--;
  }
  return s.substring(0, len);
}

export function gameName(game: GameVer) {
  switch (game) {
    case "c1":
      return "Lineage 2 C1 (Harbingers of War)";
    case "c2":
      return "Lineage 2 C2 (Age of Splendor)";
    case "c3":
      return "Lineage 2 C3 (Rise of Darkness)";
    case "c4":
      return "Lineage 2 C4 (Scions of Destiny)";
    case "c5":
      return "Lineage 2 C5 (Oath of Blood)";
    case "il":
      return "Lineage 2 IL (Interlude)";
    case "gf":
      return "Lineage 2 GF (Gracia Final)";
    default:
      return "Lineage 2";
  }
}
